import { gql, TypedDocumentNode } from "@apollo/client";

import { AwsIntegration, QueryAttachableAwsIntegrationsInSpaceArgs } from "types/generated";

type AttachableAwsIntegration = Pick<
  AwsIntegration,
  "id" | "name" | "legacy" | "generateCredentialsInWorker"
>;

export const GET_ATTACHABLE_AWS_INTEGRATIONS_FOR_SCAN: TypedDocumentNode<
  { attachableAwsIntegrationsInSpace: AttachableAwsIntegration[] },
  QueryAttachableAwsIntegrationsInSpaceArgs
> = gql`
  query GetAttachableAwsIntegrationsForScan($id: ID!) {
    attachableAwsIntegrationsInSpace(id: $id) {
      id
      name
      legacy
      generateCredentialsInWorker
    }
  }
`;
